import axios from "axios";
import * as yup from "yup";

let schema = yup.object().shape({
    content: yup.string().test("not-blank", "content.required", (content) => content?.length > 0),
});

export const validateQuestion = (question) => {
    return schema.validate(question, { abortEarly: false });
};

export const findQuestions = (headers) => {
    return axios.get(`${process.env.REACT_APP_IDP_API_URL}/sec-questions`, {
        headers,
    });
};

export const createQuestion = (headers, data) => {
    return axios.post(`${process.env.REACT_APP_IDP_API_URL}/sec-questions`, data, {
        headers,
    });
};

export const updateQuestion = (headers, id, data) => {
    return axios.patch(`${process.env.REACT_APP_IDP_API_URL}/sec-questions/${id}`, data, {
        headers,
    });
};

export const deleteQuestion = (headers, id) => {
    return axios.delete(`${process.env.REACT_APP_IDP_API_URL}/sec-questions/${id}`, {
        headers: headers,
    });
};

export const deleteQuestions = (headers, ids) => {
    return axios.delete(`${process.env.REACT_APP_IDP_API_URL}/sec-questions?id=${ids.join()}`, {
        headers: headers,
    });
};
